import React, { Component } from 'react';
import { connect } from 'react-redux';
import Link from '../../shared/Link/Link';
import Button from '../../shared/Button/Button';
import { withRouter } from 'react-router';

import { css } from '@emotion/core';

import { login } from '../../../redux/modules/user';

import './Login.scss';

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
    };
  }

  changeEmail = event => {
    this.setState({
      email: event.target.value,
    });
  };

  changePassword = event => {
    this.setState({
      password: event.target.value,
    });
  };

  login = async event => {
    event.preventDefault();

    this.props.login({
      email: this.state.email,
      password: this.state.password,
    });
  };

  render() {
    const { primaryColor, loginError } = this.props;

    const formStyle = css`
      .form-control {
        &:focus {
          border-color: ${primaryColor};
        }
      }
    `;

    return (
      <div className="login-container">
        <h1>Login</h1>

        <form className="center-block" onSubmit={this.login} css={formStyle}>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              className="form-control"
              onChange={this.changeEmail}
            />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              className="form-control"
              onChange={this.changePassword}
            />
            <Link
              to="/recupero-password"
              className="help-block"
              onClick={this.props.onCloseLogin}
            >
              Password dimenticata?
            </Link>
          </div>
          {loginError && <div className="error">{loginError}</div>}
          <div className="action">
            <Button
              type="submit"
              className="btn btn-thick btn-primary"
              style={{ width: '20rem' }}
            >
              Login
            </Button>
          </div>
          <div className="register-link">
            <p>
              <Link
                to="/registrazione"
                style={{
                  fontWeight: 'lighter',
                  color: 'black',
                  textDecoration: 'underline',
                }}
              >
                Crea un account
              </Link>
            </p>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  loginError: state.user.error,
  primaryColor: state.store.data.loghiTemplate.brandColor,
});

export default withRouter(connect(mapStateToProps, { login })(Login));
